const initialState = {
  items: [],
  count: 0,
  item: null,
  isLoading: false
};

export function subcategoryReducer(state = initialState, action) {
  const { data, subcategory: item, type } = action;
  switch (type) {
    case 'SUBCATEGORY_ERROR':
      return Object.assign({}, state, {
        isLoading: false
      });
    case 'SUBCATEGORY_CREATE':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'SUBCATEGORY_CREATE_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'SUBCATEGORY_GET':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'SUBCATEGORY_GET_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'SUBCATEGORIES_GET':
      return Object.assign({}, state, {
        items: [],
        count: 0,
        isLoading: true
      });
    case 'SUBCATEGORIES_GET_OK':
      return Object.assign({}, state, {
        items: data.items,
        count: data.count,
        isLoading: false
      });

    default:
      return state;
  }
}
